import { useState } from 'react';
import Image, { ImageProps } from 'next/image';

type FallbackImageProps = Omit<ImageProps, 'src'> & {
  src?: string | null;
  fallbackSrc?: string;
};

const FallbackImage = ({ src, fallbackSrc = '/assets/single-logo.png', alt, style, ...rest }: FallbackImageProps) => {
  const [imgSrc, setImgSrc] = useState(src || fallbackSrc);
  const [fitMode, setFitMode] = useState<'cover' | 'contain'>(src ? 'cover' : 'contain');

  const handleError = () => {
    setImgSrc(fallbackSrc);
    setFitMode('contain');
  };

  return (
    <Image
      {...rest}
      src={imgSrc}
      alt={alt}
      onError={handleError}
      style={{ objectFit: fitMode, ...style }}
    />
  );
};

export default FallbackImage;
